import React from 'react';
import '../style/brand.scss';
import Button from '../../button/components/ButtonComponent';
import isMobile from 'is-mobile';

 const Brand = (props) => {
  const openModalMobile = () => {
    if (isMobile()){
      props.openModal()
    }
  }

  return (
    <div className="brand swiper-slide" onClick={openModalMobile.bind(this)}>
      <div className="brand-image-wrapper">
        <img src={props.brand.list_image_thumbnail} alt={props.brand.name} />
        <div className="brand-footer">
          <h2>{props.brand.name}</h2>
          <div className="text-hover">{props.brand.landing_description}</div>
          <div className="brand-tags">
            {props.brand.tags.map((tag) =>
              <span key={tag.name}>#{tag.name}</span>
            )}
          </div>
          <Button onClick={props.openModal} text="SEE MORE" />
        </div>
      </div>
    </div>
  )
};
export default Brand;
